import { useIntl } from 'react-intl'
import styled from 'styled-components'

import Button from 'shared/ui/Button_2'
import Flex from 'shared/ui/Flex'
import Spinner from 'shared/ui/Spinner'
import IslandModal from 'shared/components/modals/IslandModal'

const Headline = styled.div`
  font-size: 32px;
  font-weight: 600;
  line-height: 38px;
`

const Text = styled.div`
  font-size: 22px;
  line-height: 28px;
  color: ${({ theme }) => theme.color.base.c7};
`

type ExportPendingModalProps = {
  closeModal: () => void
  isOpen: boolean
  modalWidth: number
}

const ExportPendingModal = ({
  closeModal,
  isOpen,
  modalWidth
}: ExportPendingModalProps) => {
  const { formatMessage } = useIntl()

  return (
    <IslandModal
      closeModal={closeModal}
      isOpen={isOpen}
      width={modalWidth}
    >
      <Flex
        direction="column"
        rowGap={32}
        width={644}
        marginBottom={80}
        alignItems="flex-start"
      >
        <Spinner size={48} />
        <Headline>
          {formatMessage({ id: 'Status.modal.headline.exportPending' })}
        </Headline>
        <Text>
          {formatMessage({ id: 'Status.modal.text.exportPending' })}
        </Text>
      </Flex>
      <Flex columnGap={16} justifyContent="flex-start">
        <Button
          intent="secondary-base"
          textId="Status.modal.close"
          onPress={closeModal}
          size="xl"
        />
      </Flex>
    </IslandModal>
  )
}

export default ExportPendingModal
